import React from "react";

import { formatBytes } from "utils/format";

import { useReplicationDetailsGraphQuery } from "./gql/Query.generated";
import { useDateRange } from "providers/WithDateRange";
import { Data } from "ui/Graph/util";

import DateRangeGraph from "ui/Graph/DateRangeGraph";
import GraphSection from "ui/Graph/GraphSection";
import { AreaSeries } from "ui/Graph/Series";

type Props = {
  serverId: string;
  replicationFollowerId: string;
};

const Graph: React.FunctionComponent<Props> = ({
  serverId,
  replicationFollowerId,
}) => {
  const { from, to } = useDateRange();

  const { data, loading, error } = useReplicationDetailsGraphQuery({
    variables: {
      serverId,
      replicationFollowerId,
      startTs: from.unix(),
      endTs: to.unix(),
    },
  });

  return (
    <GraphSection loading={loading} error={error}>
      <DateRangeGraph
        data={data?.getReplicationFollowerStats as unknown as Data}
        axes={{ left: { format: formatBytes } }}
        series={[
          {
            key: "totalByteLag",
            label: "Total Byte Lag",
            color: "mediumSeaGreen",
          },
          {
            key: "remoteByteLag",
            label: "Remote Byte Lag",
            type: AreaSeries,
            color: "lime",
          },
          {
            key: "localByteLag",
            label: "Local Byte Lag",
            type: AreaSeries,
            color: "yellowGreen",
          },
        ]}
      />
    </GraphSection>
  );
};

export default Graph;
